export default __webpack_public_path__ + "static/404-not-found-b0b4369ad9f18379c253c2746bdb67b4.svg";